import React from 'react'
import AppBar from '../../components/AppBar'
import storage from '../../storage'
import AssignmentStaffWorkSummarySplitView from './AssignmentStaffWorkSummarySplitView'

export default class AssignmentStaffScene extends React.Component {
  handleBackScene = () => {
    if (this.props.history) this.props.history.goBack()
  }

  render() {
    const { stationName, serviceDisplayName } = storage.info()
    return (
      <div className="pt-20 px-4 md:px-8 w-full h-screen flex flex-col">
        <AppBar
          header="Assignment"
          subHeader={`Staff (${stationName} - ${serviceDisplayName})`}
          hasBtnGroup
        />

        <div className="flex-1 overflow-hidden">
          <AssignmentStaffWorkSummarySplitView onBack={this.handleBackScene} />
        </div>
      </div>
    )
  }
}
